var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "colums small-11 medium-10 small-centered"
  }, [_c('button', {
    staticClass: "secondary button",
    attrs: {
      "disabled": !_vm.$store.state.customCheckerboard.enableControls
    },
    on: {
      "click": _vm.applySecondComponent
    }
  }, [_vm._v("\n    " + _vm._s(_vm.translations.continueSameCheckerboard) + "\n  ")])]);
}
var staticRenderFns = []

export { render, staticRenderFns }